import api from "./axios";

const base = (mintSpaceId) => `/mint-space/${mintSpaceId}/consulting`;

export const listConsultingEngagements = async (mintSpaceId, instanceId) => {
  const response = await api.get(`${base(mintSpaceId)}/engagements`, {
    params: { instanceId },
  });
  return response.data;
};

export const ensureConsultingEngagement = async (mintSpaceId, { productId, instanceId }) => {
  const response = await api.post(`${base(mintSpaceId)}/engagements/ensure`, {
    productId,
    instanceId,
  });
  return response.data;
};

export const getConsultingEngagement = async (mintSpaceId, engagementId) => {
  const response = await api.get(`${base(mintSpaceId)}/engagements/${engagementId}`);
  return response.data;
};

export const listConsultingMessages = async (mintSpaceId, engagementId, { before, limit } = {}) => {
  const response = await api.get(`${base(mintSpaceId)}/engagements/${engagementId}/messages`, {
    params: { before, limit },
  });
  return response.data;
};

export const sendConsultingMessage = async (mintSpaceId, engagementId, text, replyTo) => {
  const response = await api.post(`${base(mintSpaceId)}/engagements/${engagementId}/messages`, {
    text,
    ...(replyTo ? { replyTo } : {}),
  });
  return response.data;
};

export const closeConsultingEngagement = async (mintSpaceId, engagementId) => {
  const response = await api.post(`${base(mintSpaceId)}/engagements/${engagementId}/close`);
  return response.data;
};

export const getConsultingCallToken = async (mintSpaceId, engagementId) => {
  const response = await api.post(`${base(mintSpaceId)}/engagements/${engagementId}/call/token`, {
    consumeQuota: true,
  });
  return response.data;
};

export const getConsultingStats = async (mintSpaceId, instanceId) => {
  const response = await api.get(`${base(mintSpaceId)}/stats`, {
    params: { instanceId },
  });
  return response.data;
};

export const uploadConsultingMedia = async (mintSpaceId, engagementId, file, text = "") => {
  const formData = new FormData();
  formData.append("file", file);
  if (text) formData.append("text", text);
  const response = await api.post(
    `${base(mintSpaceId)}/engagements/${engagementId}/messages/upload`,
    formData
  );
  return response.data;
};

export const downloadConsultingMessageFile = async (mintSpaceId, engagementId, messageId) => {
  const response = await api.get(
    `${base(mintSpaceId)}/engagements/${engagementId}/messages/${messageId}/file`,
    { responseType: "blob" }
  );
  return response.data;
};

export const listConsultingRecordings = async (mintSpaceId, engagementId) => {
  const response = await api.get(
    `${base(mintSpaceId)}/engagements/${engagementId}/recordings`
  );
  return response.data;
};

export const setConsultingRecordingConsent = async (mintSpaceId, engagementId, consent = true) => {
  const response = await api.post(
    `${base(mintSpaceId)}/engagements/${engagementId}/recordings/consent`,
    { consent }
  );
  return response.data;
};

export const startConsultingRecording = async (mintSpaceId, engagementId) => {
  const response = await api.post(
    `${base(mintSpaceId)}/engagements/${engagementId}/recordings/start`
  );
  return response.data;
};

export const stopConsultingRecording = async (mintSpaceId, engagementId) => {
  const response = await api.post(
    `${base(mintSpaceId)}/engagements/${engagementId}/recordings/stop`
  );
  return response.data;
};

export const downloadConsultingRecording = async (mintSpaceId, engagementId, recordingId) => {
  const response = await api.get(
    `${base(mintSpaceId)}/engagements/${engagementId}/recordings/${recordingId}/file`,
    { responseType: "blob" }
  );
  return response.data;
};

export const publishConsultingRecordingProduct = async (
  mintSpaceId,
  engagementId,
  recordingId,
  body
) => {
  const response = await api.post(
    `${base(mintSpaceId)}/engagements/${engagementId}/recordings/${recordingId}/publish-product`,
    body
  );
  return response.data;
};

export const downloadProductConsultingRecording = async (mintSpaceId, productId) => {
  const response = await api.get(`${base(mintSpaceId)}/products/${productId}/recording-file`, {
    responseType: "blob",
  });
  return response.data;
};

export const getConsultingCalendarSettings = async (mintSpaceId, productId) => {
  const response = await api.get(`${base(mintSpaceId)}/products/${productId}/calendar`);
  return response.data;
};

export const addConsultingOneOffSlot = async (mintSpaceId, productId, body, instanceId) => {
  const response = await api.post(`${base(mintSpaceId)}/products/${productId}/calendar/one-off`, body, {
    params: instanceId ? { instanceId } : {},
  });
  return response.data;
};

export const saveConsultingCalendarSettings = async (mintSpaceId, productId, body, instanceId) => {
  const response = await api.put(`${base(mintSpaceId)}/products/${productId}/calendar`, body, {
    params: instanceId ? { instanceId } : {},
  });
  return response.data;
};

export const getConsultingCalendarMonth = async (mintSpaceId, productId, month) => {
  const response = await api.get(`${base(mintSpaceId)}/products/${productId}/calendar/month`, {
    params: month ? { month } : {},
  });
  return response.data;
};

export const getConsultingCalendarDaySlots = async (mintSpaceId, productId, day) => {
  const response = await api.get(`${base(mintSpaceId)}/products/${productId}/calendar/slots`, {
    params: { day },
  });
  return response.data;
};

export const listConsultingBookings = async (mintSpaceId, { instanceId, productId, from } = {}) => {
  const response = await api.get(`${base(mintSpaceId)}/calendar/bookings`, {
    params: { instanceId, productId, from },
  });
  return response.data;
};

export const createConsultingBooking = async (mintSpaceId, body) => {
  const response = await api.post(`${base(mintSpaceId)}/calendar/bookings`, body);
  return response.data;
};

export const createConsultingBookingHold = async (mintSpaceId, body) => {
  const response = await api.post(`${base(mintSpaceId)}/calendar/bookings/hold`, body);
  return response.data;
};

export const cancelConsultingBooking = async (mintSpaceId, bookingId) => {
  const response = await api.delete(`${base(mintSpaceId)}/calendar/bookings/${bookingId}`);
  return response.data;
};
